export function extractShortLanguage(language = ''): string {
  if (!language.includes('-')) {
    return language;
  }

  return language.split('-')[0];
}
